<template>
  <!-- 人员新增/编辑弹框 -->
  <a-modal
      :visible="props.visible"
      width="1100px"
      @cancel="handleCancel"
      @update:visible="(value) => emit('update:visible', value)"
  >
    <template #footer>
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleSubmit" :loading="submitting">
        {{ submitting ? '提交中...' : '确定' }}
      </a-button>
    </template>
    <a-form
        :model="formData"
        :rules="rules"
        ref="formRef"
        layout="vertical"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <!-- 基本信息部分 -->
        <div class="personnel-edit-section">
          <h3 class="personnel-edit-title">基本信息</h3>
          <div class="personnel-edit-row">
            <a-form-item label="人员类型" name="type">
              <a-select v-model:value="formData.type" placeholder="请选择">
                <a-select-option v-for="option in personnelTypeOptions" :key="option.value" :value="option.value">
                  {{ option.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>

            </a-form-item>
          </div>
          <div class="personnel-edit-row">
            <a-form-item label="姓名" name="name">
              <a-input v-model:value="formData.name" placeholder="" />
            </a-form-item>
            <a-form-item label="身份证号码" name="idCard">
              <a-input v-model:value="formData.idCard" placeholder="请输入身份证号码" />
            </a-form-item>
          </div>
          <div class="personnel-edit-row">
            <a-form-item label="性别" name="gender">
              <a-input v-model:value="formData.gender" />
            </a-form-item>
            <a-form-item label="联系方式" name="phone">
              <a-input v-model:value="formData.phone" placeholder="请输入联系方式" />
            </a-form-item>
          </div>
          <div class="personnel-edit-row">
            <a-form-item label="驾驶证号" name="licenseNumber">
              <a-input v-model:value="formData.licenseNumber" placeholder="请输入驾驶证号" />
            </a-form-item>
            <a-form-item label="培训日期" name="trainingDate">
              <a-date-picker v-model:value="formData.trainingDate" value-format="YYYY-MM-DD" placeholder="培训日期" format="YYYY-MM-DD" />
            </a-form-item>
          </div>
        </div>
    </a-form>
  </a-modal>
</template>

<script setup name="PersonnelEditModal">
import { defineProps, defineEmits, ref, watch } from 'vue';
import { message } from 'ant-design-vue';

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  personnel: {
    type: Object,
    default: () => ({})
  }
});

const emit = defineEmits(['update:visible', 'save']);
const formRef = ref();
const submitting = ref(false);

// 人员类型选项
const personnelTypeOptions = [
  { value: 'driver', label: '驾驶员' },
  { value: 'security', label: '安全员' }
];

// 表单数据
const formData = ref({});

// 表单验证规则
const rules = {
  // 必填项验证
  type: [
    { required: true, message: '请选择人员类型', trigger: 'change' }
  ],
  name: [
    { required: true, message: '请输入人员姓名', trigger: 'blur' }
  ],
  idCard: [
    { required: true, message: '请输入身份证号码', trigger: 'blur' }
  ],
  // gender: [
  //   { required: true, message: '请输入驾驶员性别', trigger: 'blur' }
  // ],
  // phone: [
  //   { required: true, message: '请输入驾驶员联系方式', trigger: 'blur' },
  //   { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
  // ],
  // licenseNumber: [
  //   { required: true, message: '请输入驾驶员驾驶证号', trigger: 'blur' }
  // ],
  // trainingDate: [
  //   { required: true, message: '', trigger: 'blur' }
  // ]
};

// 重置表单
const resetForm = () => {
  if (formRef.value) {
    formRef.value.resetFields();
  }
  formData.value = {
    type: '',
    name: '',
    idCard: '',
    gender: '',
    phone: '',
    licenseNumber: '',
    trainingDate: null,
  };
};

// 处理取消事件
const handleCancel = () => {
  resetForm();
  emit('update:visible', false);
};

// 处理提交事件
const handleSubmit = async () => {
  if (!formRef.value) return;

  try {
    await formRef.value.validate();
    submitting.value = true;

    // 模拟提交
    setTimeout(() => {
      // 发送保存事件
      emit('save', { ...formData.value });
      message.success('保存成功');
      handleCancel();
      submitting.value = false;
    }, 500);
  } catch (error) {
    console.error('表单验证失败:', error);
    message.error('请完善必填信息');
    submitting.value = false;
  }
};

// 监听personnel属性变化，更新表单数据
watch(() => props.personnel, (newPersonnel) => {
  if (newPersonnel && Object.keys(newPersonnel).length > 0) {
    formData.value = { ...newPersonnel };
  } else {
    // 重置表单
    resetForm();
  }
}, { deep: true });
</script>

<style scoped>
.personnel-edit-section {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.personnel-edit-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e8e8e8;
}

.personnel-edit-row {
  display: flex;
  margin-bottom: 16px;
  padding-left: 40px;
  padding-right: 40px;
  gap: 16px;
}

.personnel-edit-row > .ant-form-item {
  flex: 1;
  margin-bottom: 0;
}
</style>